import React from 'react';
import Header from './Header';
import { TablePagination } from '../Styles';
import Table from './Table';
import useFetchRecommendedAiSkuMappings from './hooks/useFetchRecommendedAiSkuMappings';

const AiSkuMapping = () => {
  const {
    aiSkuMappings,
    pageSize,
    pageNumber,
    totalResults,
    setPageNumber,
    setPageSize,
  } = useFetchRecommendedAiSkuMappings();

  return (
    <div
      style={{
        height: 'calc(100vh - 85px)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <Header />

      <div
        style={{
          flex: 1,
          minHeight: 0,
          overflow: 'auto',
          padding: '14.5px',
        }}
      >
        <Table
          aiSkuMappings={aiSkuMappings}
          pageSize={pageSize}
          pageNumber={pageNumber}
        />
      </div>

      <TablePagination
        component="div"
        count={totalResults}
        page={pageNumber - 1}
        onPageChange={(e, startingIndex) => {
          const page = startingIndex + 1;
          setPageNumber(page);
        }}
        rowsPerPage={pageSize}
        onRowsPerPageChange={e => {
          setPageSize(Number(e.target.value));
          setPageNumber(1);
        }}
      />
    </div>
  );
};

export default AiSkuMapping;
